var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "overflow-hidden h-100" }, [
    _c("div", { staticClass: "h-100" }, [
      _c(
        "div",
        {
          staticClass: "gallery-1 justify-content-center pb-20 h-100",
          class: { "p-3": this.resultPage.isMobile },
        },
        [
          _vm.isPreviewThumbnailByOutputLoading()
            ? _c("div", { staticClass: "placeholder" }, [
                _c("div", { staticClass: "animated-background" }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isPreviewThumbnailByOutputLoading() === false
            ? _c("div", { staticClass: "image h-100" }, [
                _c("img", { attrs: { src: _vm.getThumbnailForOutput() } }),
              ])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }